import React, { Component } from 'react'
import i18n from "i18next";
import ThemeManager from '../ThemeManager';

const TURNSTILE_SCRIPT_ID = 'cf-turnstile-script';
const TURNSTILE_SCRIPT_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';

export class TurnstileCaptcha extends Component {

    constructor(props) {
        super(props);
        this.widgetId = null;
        this.containerRef = React.createRef();
        this.siteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY || '';
        this.state = { scriptReady: false, error: false };
    }

    componentDidMount() {
        if (!this.isEnabled()) {
            if (this.props.onVerify !== undefined) {
                this.props.onVerify('');
            }
            return;
        }

        this.loadScript()
            .then(() => {
                this.setState({ scriptReady: true }, this.renderCaptcha);
            })
            .catch(() => {
                this.setState({ error: true });
                if (this.props.onExpire !== undefined) {
                    this.props.onExpire();
                }
            });
    }

    componentWillUnmount() {
        if (window.turnstile !== undefined && this.widgetId !== null) {
            window.turnstile.remove(this.widgetId);
        }
    }

    isEnabled = () => {
        return this.siteKey !== '';
    }

    loadScript = () => {
        return new Promise((resolve, reject) => {
            if (window.turnstile !== undefined) {
                resolve();
                return;
            }

            const currentScript = document.getElementById(TURNSTILE_SCRIPT_ID);
            if (currentScript !== null) {
                currentScript.addEventListener('load', resolve);
                currentScript.addEventListener('error', reject);
                return;
            }

            const script = document.createElement('script');
            script.id = TURNSTILE_SCRIPT_ID;
            script.src = TURNSTILE_SCRIPT_SRC;
            script.async = true;
            script.defer = true;
            script.onload = resolve;
            script.onerror = reject;
            document.body.appendChild(script);
        });
    }

    renderCaptcha = () => {
        if (this.containerRef.current === null || window.turnstile === undefined || this.widgetId !== null) {
            return;
        }

        this.widgetId = window.turnstile.render(this.containerRef.current, {
            sitekey: this.siteKey,
            theme: 'auto',
            callback: (token) => {
                if (this.props.onVerify !== undefined) {
                    this.props.onVerify(token);
                }
            },
            'expired-callback': () => {
                if (this.props.onExpire !== undefined) {
                    this.props.onExpire();
                }
            },
            'error-callback': () => {
                this.setState({ error: true });
                if (this.props.onExpire !== undefined) {
                    this.props.onExpire();
                }
            }
        });
    }

    render() {
        let themeManager = ThemeManager.getInstance();
        const _secondaryTextColor = themeManager.getSecondaryTextColor();
        const _errorColor = themeManager.getErrorColor();

        if (!this.isEnabled()) {
            return (
                <p style={{ marginTop: '15px', color: _secondaryTextColor, fontSize: '11px' }}>
                    {i18n.t('captcha.dev.disabled')}
                </p>
            )
        }

        return (
            <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'center', minHeight: '65px' }}>
                <div ref={this.containerRef}></div>
                {!this.state.scriptReady && !this.state.error &&
                    <p style={{ color: _secondaryTextColor, fontSize: '12px' }}>{i18n.t('captcha.loading')}</p>
                }
                {this.state.error &&
                    <p style={{ color: _errorColor, fontSize: '12px' }}>{i18n.t('captcha.error')}</p>
                }
            </div>
        )
    }
}

export default TurnstileCaptcha
